import { Box, Typography } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import type { StatusPillProps, StatusType } from './status-pill.types'
import { styles, statusConfigs } from './status-pill.styles'

export function StatusPill({ status, label, sx }: StatusPillProps): JSX.Element {
  const { t } = useTranslation('lib')
  const statusKey = (status in statusConfigs ? status : 'processing') as StatusType
  const config = statusConfigs[statusKey]
  const displayLabel = label || t(config.labelKey)

  const containerSx: SxProps<Theme> = {
    ...(styles.container as object),
    backgroundColor: config.backgroundColor,
    color: config.textColor,
    ...(sx as object),
  }

  return (
    <Box sx={containerSx}>
      <Box
        sx={{
          ...styles.dot,
          backgroundColor: config.dotColor,
        }}
      />
      <Typography
        component="span"
        sx={{
          fontSize: 'inherit',
          fontWeight: 'inherit',
          color: 'inherit',
        }}
      >
        {displayLabel}
      </Typography>
    </Box>
  )
}
